export default __webpack_public_path__ + "static/media/icon-nav-close.a122a9b7.svg";